import { AxiosRequestConfig, AxiosResponse } from "axios";

import { ApiClientOptions, AxiosClient } from "@services/axios/AxiosClient";

export class TixApiClient extends AxiosClient {
  constructor(options: ApiClientOptions) {
    super(options);
  }

  public async sendRequest<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return await super.sendRequest<T>(config);
  }
}
